/**
 * Convert TipTap / GFM-ish markdown emitted by the composer to Slack mrkdwn.
 * Keep this in shared code so every Slack write path applies the same encoding.
 */
const CODE_FENCE = /```([^\n`]*)\n?([\s\S]*?)```/g;
const INLINE_CODE = /`([^`]+)`/g;
function protectChunks(input, pattern, prefix) {
    const chunks = [];
    let index = 0;
    const text = input.replace(pattern, (match) => {
        const token = `\u0000${prefix}${index++}\u0000`;
        chunks.push({ token, value: match });
        return token;
    });
    return { text, chunks };
}
function restoreChunks(text, chunks) {
    return chunks.reduce((acc, chunk) => acc.split(chunk.token).join(chunk.value), text);
}
/** Map common markdown emphasis and links to Slack mrkdwn. */
export function markdownToSlackMrkdwn(markdown) {
    if (!markdown)
        return '';
    const fences = protectChunks(markdown, CODE_FENCE, 'FENCE');
    const codes = protectChunks(fences.text, INLINE_CODE, 'CODE');
    let out = codes.text;
    // Legacy composer mentions: [@Name](slack-mention:U…) -> <@U…|Name>.
    out = out.replace(/\[@?([^\]]+)\]\(slack-mention:([UW][A-Z0-9]+)\)/gi, '<@$2|$1>');
    // Links: [label](url) -> <url|label>.
    out = out.replace(/\[([^\]]+)\]\((https?:\/\/[^)\s]+)\)/g, '<$2|$1>');
    // Protect bold (GFM **/__) as placeholders before the italic pass.
    const boldChunks = [];
    let boldIndex = 0;
    const stashBold = (_match, inner) => {
        const token = `\u0000BOLD${boldIndex++}\u0000`;
        boldChunks.push({ token, value: `*${inner}*` });
        return token;
    };
    out = out.replace(/\*\*\*([^*\n]+)\*\*\*/g, (_match, inner) => stashBold(_match, `_${inner}_`));
    out = out.replace(/___([^_\n]+)___/g, (_match, inner) => stashBold(_match, `_${inner}_`));
    out = out.replace(/\*\*([^*\n]+)\*\*/g, stashBold);
    out = out.replace(/__([^_\n]+)__/g, stashBold);
    // Strikethrough ~~x~~ -> ~x~.
    out = out.replace(/~~([^~\n]+)~~/g, '~$1~');
    // Remaining single-asterisk italic -> Slack _italic_.
    out = out.replace(/(^|[^*])\*([^*\n]+)\*(?!\*)/g, '$1_$2_');
    out = restoreChunks(out, boldChunks);
    out = restoreChunks(out, codes.chunks);
    out = restoreChunks(out, fences.chunks);
    return out.replace(/\n{3,}/g, '\n\n').trimEnd();
}
//# sourceMappingURL=markdown.js.map